module.exports = __webpack_public_path__ + "img/parkingi--green.df19da67.svg";